import * as React from "react"

import { Colors } from "@tenforce/toolbox-default-style"
import { Checkbox } from "@tenforce/toolbox-selector-react"

import bem from "../../../bem"

export interface Props extends Footer.PreviewFeature {
    onEnabledChanged?: (id: number, newValue: boolean) => void
}

const b = bem.with("NewUI__previewFeature")

export const PreviewFeature = (props: Props): JSX.Element => {
    const [isEnabled, setIsEnabled] = React.useState(props.isEnabled)

    const onCheckboxToggle = (newValue: boolean): void => {
        setIsEnabled(newValue)
        props.onEnabledChanged?.(props.id, newValue)
    }

    return (
        <>
            <div className="separator-line is-dotted is-dimmed"></div>
            <div
                className={`tw-flex tw-items-center tw-justify-center tw-py-4 tw-px-6 ${b()}`}
            >
                <div className="tw-flex-1">
                    <h4>{props.label}</h4>
                    <p
                        dangerouslySetInnerHTML={{ __html: props.description }}
                    />
                </div>
                <div>
                    <Checkbox
                        isChecked={isEnabled}
                        onChecked={(): void => onCheckboxToggle(true)}
                        onUnchecked={(): void => onCheckboxToggle(false)}
                        checkColor={Colors.Jade.value}
                        extraClasses={`${b("toggle")}`}
                    />
                </div>
            </div>
        </>
    )
}
